import { render, staticRenderFns } from "./EncuestasProlipa.vue?vue&type=template&id=e0bcf94c&scoped=true"
import script from "./EncuestasProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestasProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestasProlipa.vue?vue&type=style&index=0&id=e0bcf94c&prod&scoped=true&lang=css"
import style1 from "./EncuestasProlipa.vue?vue&type=style&index=1&id=e0bcf94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bcf94c",
  null
  
)

export default component.exports